import { ReactEditor } from "slate-react";

import { MmcEditor } from "../../../type/slate-types";

const getFocusedEditor = (bodyEditor: MmcEditor, subjectEditor?: MmcEditor) => {
  return subjectEditor && ReactEditor.isFocused(subjectEditor) ? subjectEditor : bodyEditor;
};

export default getFocusedEditor;
